import { render } from "./EditAgencyDialog.vue?vue&type=template&id=065ccdcb&scoped=true"
import script from "./EditAgencyDialog.vue?vue&type=script&lang=js"
export * from "./EditAgencyDialog.vue?vue&type=script&lang=js"

import "./EditAgencyDialog.vue?vue&type=style&index=0&id=065ccdcb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065ccdcb"]])

export default __exports__